import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Button, ButtonProps } from "antd";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { Size } from "@type/sizing";
import { EnigmaTokens } from "@type/tokens";

const buttonCSS = (size, icon, iconPosition, children) => {
    if (!children) {
        switch (size) {
            case Size.medium:
                return css`
                    height: 32px;
                    padding: 0px 16px;
                `;
            case Size.large:
                return css`
                    height: 40px;
                    padding: 0px 16px;
                `;
            default:
                return css``; // Default to an empty CSS block
        }
    }
    if (icon) {
        if (iconPosition == "start") {
            switch (size) {
                case Size.medium:
                    return css`
                        height: 32px;
                        line-height: 32px;
                        text-align: center;
                        padding: 0px 16px 0px 8px;
                    `;
                case Size.large:
                    return css`
                        height: 40px;
                        padding: 0px 16px;
                    `;
                default:
                    return css``;
            }
        } else {
            switch (size) {
                case Size.medium:
                    return css`
                        height: 32px;
                        line-height: 32px;
                        text-align: center;
                        padding: 0px 8px 0px 16px;
                    `;
                case Size.large:
                    return css`
                        height: 40px;
                        padding: 0px 16px;
                    `;
                default:
                    return css``;
            }
        }
    }
    switch (size) {
        case Size.medium:
            return css`
                height: 32px;
                padding: 0px 16px;
                line-height: 32px;
                text-align: center;
            `;
        case Size.large:
            return css`
                height: 40px;
                padding: 0px 16px;
            `;
        default:
            return css``; // Default to an empty CSS block
    }
};

const customColor = () => {
    const token = useEnigmaToken();
    return css`
        &.enigma-default-button {
            color: ${token?.color?.text?.default};
        }
        &.enigma-link-button {
            color: ${token?.color?.text?.textPrimary};
        }
        &.enigma-tonal-button {
            background: ${token?.color?.bg?.fill
                ?.fillPrimarySubtler} !important;
            color: ${token?.color?.text?.textSecondary} !important;
        }
        &.enigma-tonal-button:hover {
            background: ${token?.color?.bg?.fill?.fillPrimarySubtle} !important;
        }
        &.enigma-primary-button:hover {
            background: ${token?.color?.bg?.fill?.fillPrimaryHover} !important;
        }
        &.enigma-tonal-button:focus,
        &.enigma-primary-button:focus {
            border: 1px solid ${token?.color?.border?.borderPrimary} !important;
        }
        &.enigma-primary-button:disabled,
        &.enigma-tonal-button:disabled,
        &.enigma-default-button:disabled {
            background: ${token?.color?.bg?.fill?.fillDisabled} !important;
            color: ${token?.color?.text?.textDisabled} !important;
        }
        &.enigma-default-button:hover {
            background: ${token?.color?.bg?.fill?.fillSubtler} !important;
            border: 1px solid ${token?.color?.border?.default};
            color: ${token?.color?.text} !important;
        }
        &.enigma-text-button:hover {
            background: ${token?.color?.bg?.fill?.fillSubtler} !important;
        }
        &.enigma-text-button:disabled {
            color: ${token?.color?.text?.textDisabled} !important;
        }
        &.enigma-link-button:hover {
            text-decoration: underline;
            color: ${token?.color?.text?.textPrimary} !important;
        }
        &.enigma-link-button:disabled {
            color: ${token?.color?.text?.textDisabled} !important;
        }
        box-shadow: none;
    `;
};

const isCustom = (icon) => {
    if (!icon) {
        return css`
            span.ant-btn-icon.ant-btn-loading-icon {
                position: absolute;
            }
        `;
    }
    return css`
        .enigma-button-icon {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    `;
};

export const StyledButton = styled(Button)<
    ButtonProps & { token: EnigmaTokens }
>`
    border-radius: ${({ token }) => token.radius.radiusSm};
    ${({ icon }) => isCustom(icon)}
    ${customColor}
    ${({ size, icon, iconPosition, children }) =>
        buttonCSS(size, icon, iconPosition, children)}
`;

export const StyledSpanContainer = styled.span`
    visibility: hidden;
`;
